// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"836d9bd5","239":"3cabbde0","453":"00fe8801","667":"fdc5f220"}[chunkId] + ".chunk.js";
};